import { Box } from '@mui/system';
import React from 'react';
import MediumTypography from '../../../components/formlib/MediumTypography';
import { ReactComponent as StopWhite } from '../../../assets/images/stopWhite.svg';

type IfspHeldType = {
  ifspHealBy: string | null;
};

const IfspHeld = ({ ifspHealBy }: IfspHeldType) => {
  return (
    <Box
      className="showCancelPopup"
      sx={{
        position: 'absolute',
        zIndex: 3,
        maxWidth: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        paddingTop: '34px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          marginTop: '100px',
          justifyContent: 'center',
          alignSelf: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            backgroundColor: '#EB4C60',
            width: '100%',
            padding: '24px 32px 24px 32px',
            borderRadius: '60px',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ paddingTop: '3px' }}>
            <StopWhite />
          </Box>
          <Box>
            <MediumTypography
              textColor="#FFFFFF"
              sxProps={{ marginLeft: '8px' }}
              label={`This section has been locked. ${ifspHealBy} is working on this.`}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IfspHeld;
